export default {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/src/locales",
  "moduleName": "H5-global-fe-marketing-group-global-auto-solutions-driver-service-backend",
  "version": 677,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-marketing-group-global-auto-solutions-driver-service-backend/src/locales/all.js",
  "noParse": false,
  "noOmega": false
}